import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  divider: {
    height: 1,
    backgroundColor: cloudLight,
  },
});
